import { render, staticRenderFns } from "./browser-and-version.vue?vue&type=template&id=52cc7c9c&"
import script from "./browser-and-version.vue?vue&type=script&lang=ts&"
export * from "./browser-and-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports